import { DISABLED_LABEL } from 'consts';
import { isOn } from 'util/index';
import { useFormikContext } from 'formik';

const useDisabledAndSuffix = (key, subKey) => {
  const { dirty, isSubmitting, values = [] } = useFormikContext();

  const onOff = subKey ? values?.[key]?.[subKey] : values?.[key];
  const enabled = isOn(onOff) || onOff === undefined;
  const disabled = !enabled || isSubmitting;
  const suffix = !enabled ? DISABLED_LABEL : '';

  return { dirty, disabled, suffix };
};

export default useDisabledAndSuffix;
